import { getTodayDateString } from '@/lib/date'
import { RouteState } from './types'

export const initialRouteState: RouteState = {
  charity: null,
  vehicles: [],
  donations: [],
  sortedDonations: [],
  manifest: [],
  dispatchAddress: null,
  returnAddress: null,
  currentDonation: null,
  currentDonationLoading: false,
  selectedVehicleId: null,
  selectedDate: getTodayDateString(),
  dateSelectedOn: getTodayDateString(),
  loading: false,
  vehiclesLoading: false,
  donationsLoading: false,
  error: null,
}
